export const initialState = {
  loading: false,
  success: false,
  error: null,
}

export default () => ({ ...initialState })
